import type { PublicProfileBlock } from './public-profile-builder';

/**
 * Serializes builder blocks into the PATCH payload shape.
 *
 * IMPORTANT: the config spread preserves every stored config key (`imageUrl`,
 * `items`, and anything added later). A previous version hand-picked only
 * `{url, body, buttonLabel, submitEmail}` for non-openroles blocks, which
 * silently wiped media URLs and FAQ/testimonial rows on every blocks save —
 * the API persists exactly what this function emits.
 */
export function serializeBlocks(blocks: PublicProfileBlock[]) {
  return blocks.map((block, index) => ({
    id: block.id,
    type: block.type,
    enabled: block.enabled,
    order:
      typeof block.order === 'number' && Number.isFinite(block.order) ? block.order : index,
    customTitle: block.customTitle ?? null,
    customSubtitle: block.customSubtitle ?? null,
    config:
      block.type === 'openroles'
        ? {
            ...block.config,
            url: block.config?.url ?? null,
            body: block.config?.body ?? null,
            buttonLabel: block.config?.buttonLabel ?? null,
            submitEmail: block.config?.submitEmail ?? null,
            rolesLayout: block.rolesLayout ?? block.config?.rolesLayout ?? 'tabs',
            talentPoolEnabled:
              typeof block.talentPoolEnabled === 'boolean'
                ? block.talentPoolEnabled
                : block.config?.talentPoolEnabled ?? true,
          }
        : {
            ...block.config,
            url: block.config?.url ?? null,
            body: block.config?.body ?? null,
            buttonLabel: block.config?.buttonLabel ?? null,
            submitEmail: block.config?.submitEmail ?? null,
          },
  }));
}
